"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
var PopUpTitle = (0, styled_components_1.default)('h3')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  font-size: 20px;\n  color: ", ";\n  \n  strong { font-family: Montserrat-Bold; }\n  \n  ", "\n"], ["\n  margin: 0;\n  font-size: 20px;\n  color: ", ";\n  \n  strong { font-family: Montserrat-Bold; }\n  \n  ", "\n"])), function (props) { return props.theme.colors.darkgrey; }, function (props) { return props.type === 'warning' && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    strong { \n      color: ", "; \n    }\n  "], ["\n    color: ", ";\n    strong { \n      color: ", "; \n    }\n  "])), props.theme.colors.warning, props.theme.colors.warning); });
exports.default = PopUpTitle;
var templateObject_1, templateObject_2;
//# sourceMappingURL=PopUpTitle.js.map